<template>
  <div class="ask">
    <!-- 轮播 -->
    <div class="swiper" v-if="swiperData.length > 0">
      <van-swipe :autoplay="3000" @change="onChange">
        <van-swipe-item v-for="item in swiperData" :key="item.id">
          <van-image
            lazy-load
            fit="cover"
            width="100%"
            :height="188"
            :src="item.img ? item.img : ''"
          />
          <span class="swiper_txt van-ellipsis">{{ item.title }}</span>
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">
            <span
              v-for="(item, index) in swiperData"
              :key="index"
              :class="{ active: current === index }"
            ></span>
          </div>
        </template>
      </van-swipe>
    </div>
    <!-- 金刚区 -->
    <div class="j_menus" v-if="!isWx">
      <div
        v-for="(item, index) in j_menusData"
        :key="index"
        :class="[index === 0 ? 'active1' : index === 1 ? 'active2' : 'active3']"
        @click="jumpPage(index)"
      >
        <i
          :style="{
            background: 'url(' + item.img + ') no-repeat',
            'background-size': '100% 100%',
          }"
        ></i>
        <span>{{ item.text }}</span>
      </div>
    </div>
    <!-- 话题列表 -->
    <ul class="topic-list">
      <li class="hotTopic hotTopic2">
        <div>
          <p class="title">热门话题</p>
          <span></span>
        </div>
      </li>
      <li
        @click="jumpDet(item.id, item.name)"
        class="item"
        v-for="item in topicList"
        :key="item.id"
      >
        <van-image
          class="bgimg"
          lazy-load
          fit="cover"
          width="100%"
          height="100%"
          :src="item.img ? item.img : ''"
        />
        <span
          class="bg"
          :style="{ 'background-color': cutColor(item.color) }"
        ></span>
        <div class="info">
          <p class="title van-multi-ellipsis--l2">{{ item.name }}</p>
          <div class="join flex">
            <span class="flex_1">{{ item.ask_num }}个问题</span>
            <span class="flex_1">{{ item.nums }}人关注</span>
          </div>
        </div>
      </li>
      <li v-if="topicList.length > 5" class="hotTopic" @click="jumpTopic">
        <div>
          <p class="title">更多</p>
          <p>......</p>
        </div>
      </li>
    </ul>
    <!-- 选项卡 -->
    <div class="content">
      <div class="tabMenu">
        <span @click="checkTab(0)" :class="{ active: tabIndex === 0 }"
          >最新<i :style="{ display: tabIndex === 0 ? 'block' : 'none' }"></i
        ></span>
        <span @click="checkTab(1)" :class="{ active: tabIndex === 1 }"
          >推荐<i :style="{ display: tabIndex === 1 ? 'block' : 'none' }"></i
        ></span>
      </div>
    </div>
    <!-- 最新 -->
    <div class="newMax" v-show="tabIndex === 0">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="initNewList"
      >
        <van-cell v-for="item in newList" :key="item.id">
          <a @click="jumpPage2(item.redirect_url + '&program=1')" class="item">
            <div
              class="intro"
              :style="{ height: item.resources.length > 0 ? '5rem' : 'auto' }"
            >
              <p class="van-multi-ellipsis--l2">{{ item.title }}</p>
              <span
                >{{
                  item.answer_num > 0 ? item.answer_num + "回答" : "暂无回答"
                }}&nbsp;{{ item.loves > 0 ? item.loves + "点赞" : "" }}</span
              >
            </div>
            <van-image
              lazy-load
              fit="cover"
              :width="120"
              :height="80"
              v-for="(elem, index) in item.resources"
              :key="index"
              :src="elem.cut_image"
            />
          </a>
        </van-cell>
      </van-list>
    </div>
    <!-- 推荐 -->
    <div class="newMax" v-show="tabIndex === 1">
      <van-list
        v-model="loading2"
        :finished="finished2"
        finished-text="没有更多了"
        @load="initCommandList"
      >
        <van-cell v-for="item in commandList" :key="item.id">
          <a @click="jumpPage2(item.redirect_url + '&program=1')" class="item">
            <div
              class="intro"
              :style="{ height: item.resources.length > 0 ? '5rem' : 'auto' }"
            >
              <p class="van-multi-ellipsis--l2">{{ item.title }}</p>
              <span
                >{{
                  item.answer_num > 0 ? item.answer_num + "回答" : "暂无回答"
                }}&nbsp;{{ item.loves > 0 ? item.loves + "点赞" : "" }}</span
              >
            </div>
            <van-image
              lazy-load
              fit="cover"
              :width="120"
              :height="80"
              v-for="(elem, index) in item.resources"
              :key="index"
              :src="elem.cut_image"
            />
          </a>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
import { getSwiperBanner, getIndexList, getAskTopicList } from "@/request/api";
import Contents from "@/request/base.default.js";
import { navigate, checkWx } from "@/pages/index/custom";
export default {
  data() {
    return {
      // 轮播
      current: 0,
      swiperData: [],
      // 金刚区
      j_menusData: [
        {
          text: "答题",
          img: require("../../../../../assets/img/icon_write.png"),
          color: "",
        },
        {
          text: "提问",
          img: require("../../../../../assets/img/icon_answer2.png"),
          color: "",
        },
        {
          text: "搜索更多",
          img: require("../../../../../assets/img/icon_search2.png"),
          color: "",
        },
      ],
      // 选项卡索引
      tabIndex: 0,
      // 话题列表
      topicList: [],
      // 最新列表
      newList: [],
      loading: false, // 加载中
      finished: false, // 加载完毕
      newListPage: 1,
      // 推荐列表
      commandList: [],
      loading2: false, // 加载中
      finished2: false, // 加载完毕
      commandListPage: 1,
      isWx: true,
    };
  },
  methods: {
    cutColor(color) {
      return "#" + color.substring(3);
    },
    onChange(index) {
      this.current = index;
    },
    // tab切换
    checkTab(index) {
      this.tabIndex = index;
      if (index === 1) {
        this.newListPage = 1;
        this.initCommandList(true);
      }
    },
    // 金刚区页面跳转
    jumpPage(index) {
      switch (index) {
        case 0:
          navigate("", Contents.downURL);
          break;
        case 1:
          navigate("", Contents.downURL);
          break;
        case 2:
          navigate("", Contents.mainURL + "/app/index/search");
          break;

        default:
          break;
      }
    },
    jumpTopic() {
      navigate("/askTopic");
    },
    // 话题详情
    jumpDet(id, name) {
      navigate({ path: "askTopicDet", query: { id: id, name: name } });
    },
    // 获取轮播图
    initSwiperBanner() {
      getSwiperBanner()
        .then((res) => {
          let { focus, error_code } = res;
          if (error_code === 0) {
            this.swiperData = focus;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 获取话题列表
    initTopicList() {
      let { topicPage, topicCount } = this;
      getAskTopicList({
        page: 1,
        pcount: 8,
      })
        .then((res) => {
          let { list, error_code } = res;
          if (error_code === 0) {
            this.topicList = list;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 获取最新列表
    initNewList() {
      getIndexList({
        page: this.newListPage,
        pcount: 8,
        type: 0,
      })
        .then((res) => {
          let { list, error_code } = res;
          if (error_code === 0) {
            if (list.length === 0 || !list) {
              this.finished = true;
              return false;
            }
            list.map((item) => this.newList.push(item));
            this.newListPage++;
            this.loading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 获取推荐列表
    initCommandList(comment = null) {
      getIndexList({
        page: this.newListPage,
        pcount: 8,
        type: comment ? 4 : 1,
      })
        .then((res) => {
          let { list, error_code } = res;
          if (error_code === 0) {
            if (list.length === 0 || !list) {
              this.finished2 = true;
              return false;
            }
            list.map((item) => this.commandList.push(item));
            this.commandListPage++;
            this.loading2 = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    jumpPage2(url) {
      navigate("", url);
    },
  },
  created() {
    this.isWx = checkWx();
    this.initSwiperBanner();
    this.initTopicList();
    // this.initNewList();
    // this.initCommandList();
  },
};
</script>

<style lang="less" scoped>
.newMax {
  padding-bottom: 5rem;
  .item {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 1.25rem;
    .intro {
      flex: 1;
      padding-right: 1rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      p {
        font-size: 18px;
        font-weight: 500;
        color: rgba(34, 34, 34, 1);
      }
      span {
        display: block;
        font-size: 12px;
        font-weight: 400;
        color: rgba(167, 167, 167, 1);
        margin-top: 0.625rem;
      }
    }
    .van-image {
      border-radius: 4px;
      overflow: hidden;
    }
  }
}
.tabMenu {
  width: 100%;
  height: 3.75rem;
  box-sizing: border-box;
  padding: 0 1.25rem;
  line-height: 3.75rem;
  span {
    font-size: 16px;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    position: relative;
    margin-right: 1.5rem;
    transition: all 0.3s;
    &.active {
      font-size: 24px;
      font-weight: 600;
      color: rgba(34, 34, 34, 1);
    }
  }
  i {
    width: 20px;
    height: 0.25rem;
    background: rgba(255, 76, 103, 1);
    box-shadow: 0px 2px 4px 0px rgba(255, 62, 92, 0.3);
    border-radius: 2px;
    position: absolute;
    left: 50%;
    margin-left: -10px;
    bottom: -6px;
  }
}
.hotTopic2 {
  width: 5rem;
  position: relative;
  background: linear-gradient(135deg, #ff7b9a 0%, #ff1544 100%) !important;
  &::after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: url(../../../../../assets/img/icon_msg.png) no-repeat -9px -9px;
    background-size: 50px 50px;
    opacity: 0.5;
  }
}
.topic-list {
  height: 7.25rem;
  overflow-x: auto;
  display: flex;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  padding: 16px 20px 0 20px;
  background-color: #f0f2f5;
}
.topic-list::-webkit-scrollbar {
  display: none;
}
.topic-list li {
  height: 4.75rem;
  margin-right: 0.5rem;
  position: relative;

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 300;
    opacity: 0.7;
    border-radius: 6px;
    overflow: hidden;
  }
  .bgimg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 200;
    border-radius: 0.375rem;
    overflow: hidden;
  }
}
.topic-list .item .info {
  display: inline-block;
  width: 7.5rem;
  height: 4.75rem;
  box-sizing: border-box;
  padding: 0.5rem;
  border-radius: 0.375rem;
  position: relative;
  z-index: 400;
  background-size: 100% 100%;
}
.topic-list .item > div .title {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  overflow: hidden;
  box-sizing: border-box;
  padding-left: 1.375rem;
  background: url("../../../../../assets/img/icon_msg.png") no-repeat top left;
  background-size: 1.25rem 1.25rem;
}
.topic-list .item > div .join {
  position: absolute;
  width: 100%;
  height: 1.25rem;
  left: 0;
  bottom: 0.25rem;
  overflow: hidden;
}
.topic-list .item > div .join span {
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  transform: scale(0.8);
}
.topic-list .hotTopic {
  width: 5rem;
  position: relative;
  background: linear-gradient(135deg, #2e8cff 0%, #57a3ff 100%);
  border-radius: 0.375rem;
}
.topic-list .hotTopic > div {
  width: 5rem;
  height: 4.75rem;
  box-sizing: border-box;
  padding: 0.5rem;
  position: relative;
}
.topic-list .hotTopic > div p {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  text-align: center;
  margin-top: 0.5rem;
}
.topic-list .hotTopic > div span {
  display: block;
  width: 100%;
  height: 1.25rem;
  background: url("../../../../../assets/img/icon_across.png") no-repeat center
    center;
  background-size: 1.25rem 1.25rem;
  margin-top: 0.25rem;
}
.topic-list .hotTopic::after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-size: 50px 50px;
  opacity: 0.5;
}
.j_menus {
  width: 100%;
  height: 4.5rem;
  background-color: #f8f8f8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 1rem 1.25rem;
  div {
    width: 6.5rem;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    &.active1 {
      background: linear-gradient(135deg, #9968da 0%, #7c32df 100%);
    }
    &.active2 {
      background: linear-gradient(135deg, #45ddff 0%, #2e8cff 100%);
    }
    &.active3 {
      background: linear-gradient(135deg, #ff7b9a 0%, #ff1544 100%);
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      margin-left: 2px;
    }
    i {
      width: 1.25rem;
      height: 1.25rem;
      background-size: 100% 100%;
      margin-right: 2px;
    }
  }
}
.ask {
  padding-top: 3.75rem;
  .swiper {
    box-sizing: border-box;
    padding: 0.5rem 1.25rem 1.375rem 1.25rem;
    position: relative;
    .swiper_txt {
      position: absolute;
      left: 0;
      bottom: 12px;
      box-sizing: border-box;
      padding: 0 0.75rem;
      width: 100%;
      font-size: 18px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
  }
}
.van-swipe-item {
  width: 100%;
  height: 11.75rem;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}
.van-image {
  display: block;
}
.custom-indicator {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  span {
    width: 1.875rem;
    height: 0.125rem;
    background-color: #eee;
    &.active {
      background-color: #ff4c67;
    }
  }
}
.van-swipe {
  position: static;
}
</style>